// =====================================
//
//   forgotPassword Modal
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.directive('forgotPassword', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {


            var openModal = function() {

                $ngModal.openModal('forgot-password-modal');
            }

            var closeModal = function() {

                $ngModal.closeModal('forgot-password-modal');
            }

            var sendResetPasswdMail = function(){
                
                if($scope.isSendding) {
                    return;
                }

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                    return;
                }

                $scope.isMemberFreeze = false;
                $scope.isMemberNotExist = false;
                $scope.isSystemError = false;
                $scope.isSendding = true;

                UserService.forgetPassword($scope.form.email).then(function(){
                    $scope.isSendding = false;
                    $scope.isSuccess = true;
                }, function(error){
                    $scope.isSendding = false;
                    if(error.code === 'error.formValidator.invalidMailFormat'){
                        $scope.isEmailError = true;
                    }else if(error.code === 'error.account.isFreeze'){
                        $scope.isMemberFreeze = true;
                    }else if(error.code === 'error.account.accountNotExist'){
                        $scope.isMemberNotExist = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/
            $scope.$on("OPEN_FORGOT_PASSWORD_MODAL", function(event, data) {

                openModal();
            });

                
            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: ''
            };
            $scope.isSendding = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false; // error.formValidator.invalidMailFormat
            $scope.isMemberFreeze = false; // error.account.isFreeze
            $scope.isMemberNotExist = false; // error.account.accountNotExist
            $scope.isSystemError = false;
            $scope.isSuccess = false;

            /*==========================
                Methods
            ==========================*/

            $scope.sendResetPasswdMail = sendResetPasswdMail;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/forgot_password.html';
        _dir.controller = controller;

        return _dir;
}]);